/**
 * Created by Mark on 19/04/2017.
 */


import React  from 'react';
import Layout from '../components/layouts/standard-page.js';

import DataInput from '../components/inputs/date.input.js'
import { FormattedMessage } from 'react-intl';
import MedalsService from '../services/medals-service.js';
import WordsLearntService from '../services/wordslearnt-services.js';
import ScoresService from '../services/scores-services.js';
import ScoresStore from '../store/scores-store.js';
import WordsLearntStore   from '../store/words-learnt-store.js';
import MedalStore from '../store/medals-store.js';
import MedalGraphic from '../components/media/medal.image.js';
import AreaGraph from '../components/graphs/WordsLearntGraph.js'
import BarGraph from '../components/graphs/skillsGraph.js';
import Card from '../components/card.js';
import CardBody from '../components/card-body.js';
import CardHeader from '../components/card-header.js';
import Download from '../classes/download.js';
import ActivityWidget from '../components/activity-widget.js';
import RecentActivityService from '../services/recent-activity-services.js';
import RecentActivityStore from '../store/recent-activity-store.js';
import CDNImage from '../components/media/image.js';
import domtoimage from "dom-to-image";
import jsPDF from 'jspdf';
import {Modal , Alert , Button , ControlLabel , Row , Col , FormGroup , FormControl , Breadcrumb} from 'react-bootstrap';
import AuthenticationServices from '../services/authenticate-services.js';
import AuthenticationStore    from '../store/authentication-store.js'
import InternationalizationStore from '../store/internationalization-store.js';

export default class HomeDashboardScreen extends React.Component {

    constructor(){
        super();

        var d =   new Date();
        var due = new Date(); due.setDate(due.getDate() + 14);

        this.state = {
            gold:0,
            sliver:0,
            bronze:0,
            wordsLearnt:[],
            averageScores:[],
            totalWords:0,
            recentActivity:[],
            from:d.getUnixTime(),
            to:due.getUnixTime(),
            alertVisible:false,
            days:365,
        };

    }

    componentDidMount() {

        function addMonthsUTC (date , count) {
            if (date && count) {
                var m, d = (date = new Date(+date)).getUTCDate()

                date.setUTCMonth(date.getUTCMonth() + count, 1)
                m = date.getUTCMonth()
                date.setUTCDate(d)
                if (date.getUTCMonth() !== m) date.setUTCDate(0)
            }
            return date
        }

        function timestamp (date){
            parseInt(date.getTime() / 1000).toFixed(0);
        }

        WordsLearntService.getLineGraphAccountLevel(addMonthsUTC(Date.now() , -6).getUnixTime() , new Date().getUnixTime());
        ScoresService.getAverageAccountLevel()
        RecentActivityService.getDashboard();
        AuthenticationServices.getUserData();
    }

    componentWillMount(){

        AuthenticationStore.on("GET_USER_DATA" , () => {
            this.setState({
                days: AuthenticationStore.userData.daysLeftOfSubscription,
           //     alertVisible : Number(AuthenticationStore.userData.daysLeftOfSubscription) <= 25
            })
        });

        MedalStore.on("CHANGE" , () => {
            this.setState({
                gold:MedalStore.getAccountGold(),
                silver:MedalStore.getAccountSilver(),
                bronze:MedalStore.getAccountBronze(),
            });
        });

        ScoresStore.on("CHANGE" , () => {
            this.setState({
                averageScores:ScoresStore.getAccountAverage(),
            });
        });

        WordsLearntStore.on("CHANGE" , () => {
            this.setState({
                wordsLearnt:WordsLearntStore.getAccountCommunicative(),
                totalWords:WordsLearntStore.getAccountTotal(),
            });
        });

        RecentActivityStore.on("CHANGE" , () => {

            this.setState({
                recentActivity:RecentActivityStore.getDashboard(),
            });
        });
    }

    downloadDashboardWordsLearnt(){
        var node = document.getElementById('content');

        domtoimage.toPng(node)
            .then(function (dataUrl) {
                var img = new Image();
                img.src = dataUrl;
                document.body.appendChild(img);
            })
            .catch(function (error) {
                console.error('oops, something went wrong!', error);
            });

        var pdf = new jsPDF('p', 'pt', 'letter');

    }

    downloadChart(){

        var node = document.getElementById('WordsLearnt');

        domtoimage.toPng(node)
            .then(function (dataUrl) {
                var img = new Image();
                img.src = dataUrl;
                document.body.appendChild(img);
            })
            .catch(function (error) {
                console.error('oops, something went wrong!', error);
            });

        var pdf = new jsPDF('p', 'pt', 'letter');
        // source can be HTML-formatted string, or a reference
        // to an actual DOM element from which the text will be scraped.
        var source = "<h1>Mark Smith</h1>";

        console.log(source);
        // we support special element handlers. Register them with jQuery-style
        // ID selector for either ID or node name. ("#iAmID", "div", "span" etc.)
        // There is no support for any other type of selectors
        // (class, of compound) at this time.
        var specialElementHandlers = {
            // element with id of "bypass" - jQuery style selector
            '#bypassme': function(element, renderer) {
                // true = "handled elsewhere, bypass text extraction"
                return true
            }
        };
        var margins = {
            top: 80,
            bottom: 60,
            left: 40,
            width: 522
        };
        // all coords and widths are in jsPDF instance's declared units
        // 'inches' in this case
        pdf.fromHTML(
            source, // HTML string or DOM elem ref.
            margins.left, // x coord
            margins.top, {// y coord
                'width': margins.width, // max width of content on PDF
                'elementHandlers': specialElementHandlers
            },
            function(dispose) {
                // dispose: object with X, Y of the last line add to the PDF
                //          this allow the insertion of new lines after html
                pdf.save('Test.pdf');
            }
            , margins);

    };

    renderGraph(graph , title){
        return  <Card>
                    <CardHeader>
                        <h2>{title}</h2>
                    </CardHeader>
                    <CardBody noPadding>
                        {graph}
                    </CardBody>
                </Card>
    }

    getBreadCrumb(){

        return  <Breadcrumb>
                    <Breadcrumb.Item active >
                        <FormattedMessage id={ 'ui-779' } defaultMessage={ '' }/>
                    </Breadcrumb.Item>
                </Breadcrumb>
    }

    handelSetDataSelect(){

    }

    handleAlertDismiss() {
        this.setState({ alertVisible: false });
    }

    handleAlertShow() {
        this.setState({ alertVisible: true });
    }

    gotoBuynow(){
        window.location.hash = 'subscription';
    }

    render(){

        let download = <button  className="btn  btn-primary b-btn-icon-text waves-effect pull-right"><i className="palette-White text zmdi zmdi-download"></i>  <FormattedMessage id={ String("ui-474")} defaultMessage={ "Download Report" } /></button>

        let msg = InternationalizationStore.getTranslation("ui-377" , "").replace("X" , this.state.days);
        let alert = null;

        if (this.state.alertVisible) {
            alert = <Row>
                <Alert bsStyle="danger" onDismiss={this.handleAlertDismiss.bind(this)}>
                    <p><strong>{msg}</strong></p>
                    <p>
                        <Button onClick={this.gotoBuynow.bind(this)}><FormattedMessage id={ String("ui-400")} defaultMessage={ "Buy Now" } /></Button>
                    </p>
                </Alert>
            </Row>
        }

        return (<Layout>
            {alert}
            {this.getBreadCrumb()}

            <Row>
                
                 <Col sm={7}>
                     {this.renderGraph( <ActivityWidget data={this.state.recentActivity}/> , <FormattedMessage id={ 'ui-466' } defaultMessage={ 'Recent Activity' }/>)}</Col>
                 <Col sm={5}>
                     {this.renderGraph( <AreaGraph  dataKeys={[{key:'words' , fill:'#32C388'}]} data={this.state.wordsLearnt} height={200} id="progressSkills"/> , <FormattedMessage id={ 'ui-97' } defaultMessage={ 'Words Learnt' }/>)}
                 </Col>
                 <Col sm={5} id="WordsLearnt" className="pull-right">
                    {this.renderGraph( <BarGraph dataKeys={[{key:'score'}]} data={this.state.averageScores} height={203} id="averageScores"/>, <FormattedMessage id={ 'ui-909' } defaultMessage={ 'Words Learnt by Skill' }/>)}
                 </Col>
            </Row>
        </Layout>);
    }
}


// WEBPACK FOOTER //
// ./src/screens/dashboard.js